import type { StaffPortalReadiness } from "@/lib/staff-portal-readiness";

export interface FullscreenChatEntry {
  isWidget: boolean;
  fromPortal: boolean;
  hasAuthenticatedUser: boolean;
}

/** A staff-only chat entry is created by the portal after sign-in. */
export function isVerifiedStaffPortalEntry(entry: FullscreenChatEntry): boolean {
  return !entry.isWidget && entry.fromPortal && entry.hasAuthenticatedUser;
}

/** Public shared full-screen links must never redirect for staff readiness. */
export function shouldRedirectUnreadyStaffPortal(
  entry: FullscreenChatEntry,
  readiness: StaffPortalReadiness | undefined,
): boolean {
  return isVerifiedStaffPortalEntry(entry) && readiness?.isReady !== true;
}